import * as S from "effect-app/Schema"

export const PriceTargetKind = S.Literals(["listItem", "numberOption", "basePrice"])
export type PriceTargetKind = typeof PriceTargetKind.Type

export class PriceTarget extends S.Opaque<PriceTarget, PriceTarget.Encoded>()(
  S
    .Struct({
      kind: PriceTargetKind,
      // the object's own id: item.id or option.id. null only for the base price,
      // which is a field on the configurator rather than an object of its own.
      id: S.NullOr(S.StringId),
      optionId: S.NullOr(S.StringId), // unchanged, used for navigation only
      label: S.NonEmptyString2k,
      // null = the object carries no price ID yet; the bulk table can assign one
      priceId: S.NullOr(S.NonEmptyString255),
      // wide on purpose: NumberOption.stepPrice is NullOr(Finite), null/negative are valid current values
      price: S.NullOr(S.Finite),
      swissPrice: S.NullOr(S.NonNegativeDecimal),
      supportsSwissPrice: S.Boolean
    })
    .annotate({ identifier: "PriceTarget" })
) {}

export class PriceTargetAddress extends S.Opaque<PriceTargetAddress, PriceTargetAddress.Encoded>()(
  S
    .Struct({
      kind: PriceTargetKind,
      // the object's own id: item.id or option.id. null only for the base price,
      // which is a field on the configurator rather than an object of its own.
      id: S.NullOr(S.StringId)
    })
    .annotate({ identifier: "PriceTargetAddress" })
) {}

export class PriceUpdateChange extends S.Opaque<PriceUpdateChange, PriceUpdateChange.Encoded>()(
  S
    .Struct({
      // `kind` rides along even though `id` alone identifies the object: the server needs it
      // to know which field to write (item.price / option.stepPrice / configurator.basePrice)
      // without first discovering the object's type.
      kind: PriceTargetKind,
      id: S.NullOr(S.StringId),
      // declarative: the desired final value, null = the object ends up with no price ID.
      // Deliberately NOT the shared `PriceId` schema from shared.ts: that one carries a
      // withDecodingDefault(null), which would turn a client omitting the key into a silent
      // mass removal instead of a decode error.
      priceId: S.NullOr(S.NonEmptyString255),
      price: S.NullOr(S.NonNegativeDecimal), // null = leave the EUR price untouched
      swissPrice: S.NullOr(S.NonNegativeDecimal) // null = leave the CHF price untouched
    })
    .annotate({ identifier: "PriceUpdateChange" })
) {}

// codegen:start {preset: model}
//
export namespace PriceTarget {
  export interface Encoded extends S.StructNestedEncoded<typeof PriceTarget> {}
}
export namespace PriceTargetAddress {
  export interface Encoded extends S.StructNestedEncoded<typeof PriceTargetAddress> {}
}
export namespace PriceUpdateChange {
  export interface Encoded extends S.StructNestedEncoded<typeof PriceUpdateChange> {}
}
//
// codegen:end
